// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

import { dateOf } from '@/lib/time';

export default {
	columns : {
		reviewsKey : {
			title  : 'ID',
			sort   : 'number',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 0,
		},

		firmDescription : {
			title        : 'Agency',
			sort         : 'string',
			filter       : 'string',
			index        : true,
			hidden       : false,
			order        : 1,
			filterColumn : 'firm.description',
		},

		reviewsTypesAbbreviation : {
			title         : 'Review Types',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 2,
			filterColumn  : 'reviewsTypes.abbreviation',
			key           : 'reviewsTypes',
			transformText : a => a.reduce( ( allReviewsTypes, reviewType, index ) => {

				const formattedReviewTypeText = `${reviewType.abbreviation}`;
				const reviewTypeList          = `${allReviewsTypes}${formattedReviewTypeText}`;

				if ( index === a.length - 1 ) {
					return reviewTypeList;
				}

				return `${reviewTypeList}<br>`;
			}, '' ),
		},

		dateReceived : {
			title         : 'Received Date',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 3,
			transformText : dateOf,
		},

		dateDeadline : {
			title         : 'Deadline Date',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 4,
			transformText : dateOf,
		},

		dateResponse : {
			title         : 'Response Date',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 5,
			transformText : dateOf,
		},

		responseBy : {
			title  : 'Response By',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 6,
		},

		facilities : {
			title         : 'Facility',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 7,
			filterColumn  : 'facilities.[name,number]',
			key           : 'facilities',
			transformText : a => a.reduce( ( allFacilities, facility, index ) => {

				const formattedFacilityText = `${facility.name} No. ${facility.number}`;
				const facilityList          = `${allFacilities}${formattedFacilityText}`;

				if ( index === a.length - 1 ) {
					return facilityList;
				}

				return `${facilityList}<br>`;

			}, '' ),
		},

		locationDescription : {
			title        : 'Cross Streets',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 8,
			filterColumn : 'location.description',
		},

		referenceNumber : {
			title  : 'Ref',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 9,
		},

		apn : {
			title  : 'APN',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 10,
		},

	},

	dropdownOptions : {}
};
